import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestService } from './request.service';
import { ConfigApi } from '../data/api.data';
import { DomainConfigI } from '../interfaces/config.interface';
import { Meta, Title } from '@angular/platform-browser';
import { CookieService } from './cookie.service';
import { LocalStoreEnums } from '../enums/store.enum';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AppThemeService {
  constructor(
    private reqS: RequestService,
    private metaService: Meta,
    private titleService: Title,
    private cookie: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  // Method to fetch theme data
  getThemeData() {
    const domain = window.location.hostname;
    return this.reqS.get<{ data: DomainConfigI }>(
      `${ConfigApi.domain}?domain=${domain}&type=admin`
    );
  }

  setThemeCookie(theme: DomainConfigI) {
    this.cookie.setCookie({
      name: LocalStoreEnums.THEME,
      value: theme,
      expiration: true,
      expireDays: 5,
    });
  }

  get getAppTheme(): DomainConfigI | null {
    if (!this.isBrowser) return null;

    try {
      const hostname = window.location.hostname;
      const cookieKey = `_theme_${hostname}`;
      const cookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${cookieKey}=`))
        ?.split('=')[1];

      if (cookie) {
        return JSON.parse(decodeURIComponent(cookie));
      }
    } catch (err) {
      return null;
    }

    return null;
  }
  get getLogo() {
    return '../../../assets/images/logo.jpg';
  }
}
